<template>
  <section>
    <article>
      <div class="banana">
        <div class="name text-center">
          Eric Milliot
        </div>
        <hr class="hr">
        <!-- <div class="title text-center">
        <span class="letter">F</span>
        <span class="letter">U</span>
        <span class="letter">L</span>
        <span class="letter">L</span>
        <span class="letter">S</span>
        <span class="letter">T</span>
        <span class="letter">A</span>
        <span class="letter">C</span>
        <span class="letter">K</span>
        <span class="letter">-</span>
        <span class="letter">D</span>
        <span class="letter">E</span>
        <span class="letter">V</span>
        <span class="letter">E</span>
        <span class="letter">L</span>
        <span class="letter">O</span>
        <span class="letter">P</span>
        <span class="letter">E</span>
        <span class="letter">R</span>
      </div> -->
        <div class="title text-center">
          <span class="letter">S</span>
          <span class="letter">O</span>
          <span class="letter">F</span>
          <span class="letter">T</span>
          <span class="letter">W</span>
          <span class="letter">A</span>
          <span class="letter">R</span>
          <span class="letter">E</span>
          <span class="letter">-</span>
          <span class="letter">E</span>
          <span class="letter">N</span>
          <span class="letter">G</span>
          <span class="letter">I</span>
          <span class="letter">N</span>
          <span class="letter">E</span>
          <span class="letter">E</span>
          <span class="letter">R</span>
        </div>
      </div>
    </article>
    <!-- <footer>
      <span>Made with</span> <a href="http://anime-js.com">anime.js</a>
    </footer> -->
    <!-- <a
      class="logo"
      href="http://anime-js.com"
    ><img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/1137/anime-logo.png"></img></a> -->
  </section>
</template>

<script>
  import anime from 'animejs/lib/anime.es.js'
  export default {
    name: 'SectionAffiliates',
    mounted () {
      this.animate()
    },
    methods: {
      animate: function () {
        anime({
          targets: ['.name', '.title'],
          translateX: [
            { value: 250, duration: 1000, delay: 500 },
            { value: 0, duration: 1000, delay: 500 },
          ],
          translateY: [
            { value: -40, duration: 500 },
            { value: 40, duration: 500, delay: 1000 },
            { value: 0, duration: 500, delay: 1000 },
          ],
          scaleX: [
            { value: 4, duration: 100, delay: 500, easing: 'easeOutExpo' },
            { value: 1, duration: 900 },
            { value: 4, duration: 100, delay: 500, easing: 'easeOutExpo' },
            { value: 1, duration: 900 },
          ],
          scaleY: [
            { value: [1.75, 1], duration: 500 },
            { value: 2, duration: 50, delay: 1000, easing: 'easeOutExpo' },
            { value: 1, duration: 450 },
            { value: 1.75, duration: 50, delay: 1000, easing: 'easeOutExpo' },
            { value: 1, duration: 450 },
          ],
          easing: 'easeOutElastic(1, 2',
          loop: false,
          rotate: '1turn',
          scale: 3,
          delay: 100,
          opacity: ['0%', '100%'],
        })
        anime({
          targets: '.hr',
          backgroundColor: '#FFF',
          opacity: ['0%', '100%'],
          easing: 'easeInOutQuad',
          width: '60%',
          delay: 5000,
        })
        anime({
          targets: '.letter',
          opacity: 1,
          translateY: 7,
          rotate: {
            value: 360,
            duration: 1500,
            easing: 'easeInExpo',
          },
          // scale: anime.stagger([0.5, 1], { from: 'center' }),
          delay: anime.stagger(100, { start: 1000 }),
          translateX: [-40, 2],
        })
      },
    },
  }
</script>
<style scoped>
.name {
  width: 40%;
  height: 2rem;
  margin: auto;
  margin-top: 10em;
  /*  */
}
.hr {
  width: 0%;
  margin-top: 10em;
  margin: auto;
  max-width: 100%;
}
.title {
  width: 100%;
  max-width: 100%;
  margin: auto;
  /* margin-top: 1em; */
  /* display: inline-block; */
}
.letter {
  display: inline-block;
  opacity: 0;
}
.banana {
  width: 100%;
  max-width: 100%;
}

@media (max-width:960px) {
  .title {
      margin-top: 10%;
    width: 35%;
    max-width: 100%;
    margin: none;
    /* margin-top: 1em; */
    /* display: inline-block; */
  }
}
/* div {
  display: inline-block;
} */
</style>
